"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_IDENTITIES = exports.GET_IDENTITIES = void 0;
var _actionify = require("@mulesoft/actionify");
// eslint-disable-next-line import/no-extraneous-dependencies

var UPDATE_IDENTITIES = exports.UPDATE_IDENTITIES = (0, _actionify.buildActionsFor)('Update Identities');
var GET_IDENTITIES = exports.GET_IDENTITIES = (0, _actionify.buildActionsFor)('Get Identities');
//# sourceMappingURL=actionTypes.js.map